import type { LatLng } from './types';

/** Called only after the user presses the location button. */
export function requestDeviceLocation(
  geolocation: Pick<Geolocation, 'getCurrentPosition'> | undefined =
    typeof navigator === 'undefined' ? undefined : navigator.geolocation,
): Promise<LatLng & { accuracy: number }> {
  return new Promise((resolve, reject) => {
    if (!geolocation) {
      reject(new Error('Device location is unavailable'));
      return;
    }
    geolocation.getCurrentPosition(
      ({ coords }) => {
        if (!Number.isFinite(coords.latitude) || !Number.isFinite(coords.longitude)) {
          reject(new Error('Invalid device location'));
          return;
        }
        resolve({ lat: coords.latitude, lng: coords.longitude, accuracy: coords.accuracy });
      },
      reject,
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 },
    );
  });
}
